export const initialIdentityList = {
  idenfiticationSource1: "",
  idenfiticationSource2: "",
  driverLicenceNumber: "",
  driverLicenceCardNumber: "",
  driversLicenceState: "",
  driversLicenceExpiry: "",
  medicareCardNumber: "",
  medicareInitial: "",
  medicareColour: "",
  medicareReferenceNumber: "",
  medicareExpiry: "",
  passportNumber: "",
  passportCountry: "",
};

export const defaultIncomeSourceValue = "Salary & Wages";

export const incomeSourceOptionsUpdated = [
  { value: "rental-income", label: "Rental Income" },
  {
    value: "self-employed-business-income",
    label: "Self Employed Business Income",
  },
  {
    value: "government-benefits",
    label: "Government Benefits",
  },
  {
    value: "investments-interest",
    label: "Investment Income - Interest",
  },
  {
    value: "investments-dividends",
    label: "Investment Income - Dividends",
  },
];

export const initialOtherIncomeList = {
  hasOtherIncomes: "",
  otherIncomeSource_1: "",
  otherIncomeAmount_1: "",
  otherIncomeFrequency_1: "",
  otherIncomeSource_2: "",
  otherIncomeAmount_2: "",
  otherIncomeFrequency_2: "",
  otherIncomeSource_3: "",
  otherIncomeAmount_3: "",
  otherIncomeFrequency_3: "",
};

export const significantChangeValues = [
  {
    value: "expenseIncreaseShortTerm",
    formValue: "short_term_increase_in_expenses",
  },
  {
    value: "expenseIncreaseLongTerm",
    formValue: "long_term_increase_in_expenses",
  },
  {
    value: "incomeDecreaseShortTerm",
    formValue: "short_term_decrease_in_income",
  },
  {
    value: "incomeDecreaseLongTerm",
    formValue: "long_term_decrease_in_income",
  },
];

export const validLoanTerms = ["3", "5", "7"];

export const PURPOSE_CONSOLIDATION = "consolidation";

export const CONSOLIDATION_PURPOSES = [
  PURPOSE_CONSOLIDATION,
  "consolidation-debtbustr",
];

export type LoanInterestRate = {
  financeCompany: string;
  interestRate: number;
};
